import { BadgeCheck, Globe2, LifeBuoy, Shield } from "lucide-react";

const WhyRegister = () => {
	const reasons = [
		{
			Icon: Shield,
			preTitle: "Government-Backed Recognition",
			title: "Official Authorization & Compliance",
			description:
				"All registered projects receive official recognition from the Royal Government of Cambodia (RGC), ensuring compliance with national policies and international carbon mechanisms.",
		},
		{
			Icon: BadgeCheck,
			preTitle: "Transparent & Verified Process",
			title: "Robust Monitoring & Verification",
			description:
				"All projects undergo rigorous validation, monitoring, and verification by independent third-party verifiers to guarantee the accuracy and credibility of emission reductions achieved.",
		},
		{
			Icon: LifeBuoy,
			preTitle: "Support & Guidance",
			title: "Expert Assistance Throughout the Process",
			description:
				"We provide comprehensive, step-by-step guidance, employing clear methodologies and expert regulatory support. This enables project proponents to navigate and complete the registration process efficiently and effectively.",
		},
		{
			Icon: Globe2,
			preTitle: "Global Alignment",
			title: "Recognition Under International Standards",
			description:
				"By aligning registered projects under Cambodia’s National Carbon Registry not only enhances their credibility but also opens doors to international recognition and collaboration.",
		},
	];
	return (
		<section className="py-10 px-5 lg:px-0">
			<div className="container mx-auto max-w-7xl">
				<div className="space-y-5 text-center">
					<div className="space-y-5">
						<p className="text-xl md:text-3xl">WHY</p>
						<p className="text-3xl md:text-4xl font-bold text-primary">
							Why Register Your Carbon Project With Us?
						</p>
					</div>
					<div>
						<p className="text-center text-[20px] px-0 lg:px-80">
							The Cambodia Carbon Registry serves as a robust framework to
							ensure transparency, credibility, and compliance for greenhouse
							gas reduction projects. By registering with us, stakeholders can
							benefit from official recognition and independent third-party
							verification, while aligning with rigorous international carbon
							standards.
						</p>
					</div>
				</div>
				<div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 my-12">
					{reasons.map((item, index: number) => {
						return (
							<div
								className="bg-white text-center shadow-xl border-2 border-base-200 rounded-xl p-10 min-h-96"
								key={index}
							>
								<span className="inline-block mb-5">
									<item.Icon
										size={60}
										strokeWidth={1}
										className="text-primary"
									/>
								</span>
								<div className="space-y-2">
									<span className="uppercase opacity-60">{item.preTitle}</span>
									<p className="font-bold text-xl">{item.title}</p>
									<p className="text-sm opacity-80">{item?.description}</p>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default WhyRegister;
